<div class="chgrequest-tab">
  
  <!-- ブロック1: 未処理リスト -->
  <div class="chgrequest-block unprocessed-block" *ngIf="showUnprocessedBlock">
    <h2 class="block-title">変更申請リスト（未処理）</h2>
    
    <div class="table-container">
      <table class="chgrequest-table">
        <thead>
          <tr>
            <th class="text-center">処理</th>
            <th class="text-right">No</th>
            <th class="text-center">獲注番号</th>
            <th class="text-center">ASC登録番号</th>
            <th class="text-center">部署コード</th>
            <th class="text-center">元開始日</th>
            <th class="text-center">元終了日</th>
            <th class="text-center">削除開始日</th>
            <th class="text-left">削除/変更種類</th>
            <th class="text-center">発生日</th>
            <th class="text-center">前払い</th>
            <th class="text-left">支店担当者</th>
            <th class="text-left">処理状況</th>
            <th class="text-left">処理担当者</th>
            <th class="text-center">処理更新日時</th>
            <th class="text-left comment-col">処理コメント</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of unprocessedRequests">
            <td class="text-center">
              <button class="btn btn-primary btn-sm" (click)="onShowDetail(request)">
                表示
              </button>
            </td>
            <td class="text-right">
              <a *ngIf="request.procStatusCode === 6" 
                 (click)="navigateToTransfer(request.requestID)" 
                 style="color: #007bff; text-decoration: underline; cursor: pointer;">
                {{ request.requestID }}
              </a>
              <span *ngIf="request.procStatusCode !== 6">{{ request.requestID }}</span>
            </td>
            <td class="text-center">{{ request.jobOrderID }}</td>
            <td class="text-center">{{ request.userCode }}</td>
            <td class="text-center">{{ request.customerOfficeCode }}</td>
            <td class="text-center">{{ request.oldStartDate }}</td>
            <td class="text-center">{{ request.oldEndDate }}</td>
            <td class="text-center">{{ request.cutDate }}</td>
            <td class="text-left">{{ request.chgReason }}</td>
            <td class="text-center">{{ request.createDate }}</td>
            <td class="text-center">{{ request.prePay }}</td>
            <td class="text-left">{{ request.repName }}</td>
            <td class="text-left">{{ request.procStatus }}</td>
            <td class="text-left">{{ request.procUserName }}</td>
            <td class="text-center">{{ request.procDate }}</td>
            <td class="text-left comment-col">{{ request.procComment }}</td>
          </tr>
          <tr *ngIf="!isLoadingUnprocessed && unprocessedRequests.length === 0">
            <td colspan="16" class="text-center">未処理のデータはありません</td>
          </tr>
          <tr *ngIf="isLoadingUnprocessed">
            <td colspan="16" class="text-center">読み込み中...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ページング -->
    <div class="pagination-container" *ngIf="unprocessedTotalPages > 1">
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === 1" (click)="onUnprocessedPageChange(1)">
        &lt;&lt;
      </button>
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === 1" (click)="onUnprocessedPageChange(unprocessedPageNo - 1)">
        &lt;
      </button>
      <button 
        *ngFor="let page of getUnprocessedPageNumbers()" 
        class="btn btn-sm"
        [class.active]="page === unprocessedPageNo"
        (click)="onUnprocessedPageChange(page)">
        {{ page }}
      </button>
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === unprocessedTotalPages" (click)="onUnprocessedPageChange(unprocessedPageNo + 1)">
        &gt;
      </button>
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === unprocessedTotalPages" (click)="onUnprocessedPageChange(unprocessedTotalPages)">
        &gt;&gt;
      </button>
      <span class="page-info">{{ unprocessedPageNo }} / {{ unprocessedTotalPages }} ページ (全{{ unprocessedTotalRecords }}件)</span>
    </div>
  </div>

  <!-- ブロック2: 詳細表示 -->
  <div class="chgrequest-block detail-block" *ngIf="showDetailBlock">
    <h2 class="block-title">変更申請内容</h2>

    <div *ngIf="isLoadingDetail" class="loading-message">
      詳細を読み込んでいます...
    </div>

    <div *ngIf="!isLoadingDetail && selectedRequest">
      <!-- 概要表 -->
      <table class="summary-table">
        <tbody>
          <tr>
            <th>削除/変更種類</th>
            <td>{{ selectedRequest.chgReason }}</td>
            <th>申請番号</th>
            <td>{{ selectedRequest.requestID }}</td>
            <th>申請日時</th>
            <td>{{ selectedRequest.createDate }}</td>
            <th>支店担当者</th>
            <td>{{ selectedRequest.repName }}</td>
          </tr>
          <tr>
            <th>元の契約期間</th>
            <td>{{ getOldPeriod() }}</td>
            <th>獲注ID</th>
            <td>
              <a href="javascript:void(0)" class="link-text" (click)="onShowJobOrder(selectedRequest.jobOrderID)">{{ selectedRequest.jobOrderID }}</a>
            </td>
            <th>ASC登録番号</th>
            <td>
              <a href="javascript:void(0)" class="link-text" (click)="onShowASCInfo(selectedRequest.userCode)">{{ selectedRequest.userCode }}</a>
            </td>
            <th>ASC氏名</th>
            <td>{{ selectedRequest.staffName }}</td>
          </tr>
          <tr>
            <th>更新契約期間</th>
            <td>{{ getNewPeriod() }}</td>
            <th>部署コード</th>
            <td>
              <a href="javascript:void(0)" class="link-text" (click)="onShowCustomerInfo(selectedRequest.customerOfficeCode)">{{ selectedRequest.customerOfficeCode }}</a>
            </td>
            <td colspan="4">{{ selectedRequest.customerName }}</td>
          </tr>
          <tr>
            <th>担当者コメント</th>
            <td colspan="7">{{ selectedRequest.requestComment }}</td>
          </tr>
        </tbody>
      </table>

      <!-- 状態表示とメッセージ -->
      <div class="status-area">
        <div class="status-message">
          状態：[{{ selectedRequest.dataStatus ?? selectedRequest.dataStatusCode }}] {{ getStatusMessage() }}
        </div>
        <!-- 保存成功メッセージ -->
        <div *ngIf="saveSuccessMessage" class="save-success-message">
          {{ saveSuccessMessage }}
        </div>
      </div>

      <!-- 処理エリア -->
      <div class="process-area">
        <div class="process-blocks-container">
          <!-- 3つのブロック -->
          <div class="process-blocks">
            <!-- ブロック1: BillPay Check -->
            <div class="process-block">
              <h3>1. BillPay Check</h3>
              <div class="option-group">
                <label class="radio-label">
                  <input type="radio" name="billpay" value="0" [(ngModel)]="billpayOption" (ngModelChange)="onBillpayOptionChange()" [disabled]="isPendingConfirmation">
                  <span [class.disabled-text]="isPendingConfirmation">BPデータが取消せないか、処理は実行できない</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="billpay" value="1" [(ngModel)]="billpayOption" (ngModelChange)="onBillpayOptionChange()" [disabled]="isPendingConfirmation || isBillpayShortenDisabled">
                  <span [class.disabled-text]="isPendingConfirmation || isBillpayShortenDisabled">取消可能な日まで短縮：</span>
                  <input type="text" class="date-input" placeholder="yyyy/mm/dd" [(ngModel)]="shortDateValue" (input)="formatShortDateInput($event)" [disabled]="isPendingConfirmation || isBillpayShortenDisabled">
                </label>
                <label class="radio-label">
                  <input type="radio" name="billpay" value="2" [(ngModel)]="billpayOption" (ngModelChange)="onBillpayOptionChange()" [disabled]="isPendingConfirmation">
                  <span [class.disabled-text]="isPendingConfirmation">依頼通りに短縮/削除</span>
                </label>
              </div>
            </div>

            <!-- ブロック2: 処理状況の記録 -->
            <div class="process-block">
              <h3>2. 処理状況の記録</h3>
              <div class="option-group two-column">
                <label class="radio-label">
                  <input type="radio" name="status" value="1" [(ngModel)]="statusOption" (ngModelChange)="clearSaveMessage()" [disabled]="isPendingConfirmation">
                  <span [class.disabled-text]="isPendingConfirmation">BillPay確認中</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="status" value="2" [(ngModel)]="statusOption" (ngModelChange)="clearSaveMessage()" [disabled]="isPendingConfirmation">
                  <span [class.disabled-text]="isPendingConfirmation">担当者問合中</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="status" value="3" [(ngModel)]="statusOption" (ngModelChange)="clearSaveMessage()" [disabled]="isPendingConfirmation">
                  <span [class.disabled-text]="isPendingConfirmation">Pending</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="status" value="4" [(ngModel)]="statusOption" (ngModelChange)="clearSaveMessage()" [disabled]="isPendingConfirmation">
                  <span [class.disabled-text]="isPendingConfirmation">その他</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="status" value="5" [(ngModel)]="statusOption" (ngModelChange)="clearSaveMessage()" [disabled]="!isConfirmCompleteEnabled || isPendingConfirmation">
                  <span [class.disabled-text]="!isConfirmCompleteEnabled || isPendingConfirmation">確認完了</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="status" value="6" [(ngModel)]="statusOption" disabled>
                  <span class="disabled-text">確定待ち</span>
                </label>
              </div>
            </div>
          </div>

          <!-- 処理コメント行 -->
          <div class="comment-row">
            <label>処理コメント</label>
            <input type="text" class="comment-input" [(ngModel)]="processComment" (ngModelChange)="clearSaveMessage()" [disabled]="isPendingConfirmation">
          </div>
        </div>

        <!-- 保存ボタン -->
        <div class="save-button-area">
          <button class="btn btn-close-detail" (click)="onCloseDetail()">閉じる</button>
          <button class="btn btn-primary" (click)="onSaveProcess()" [disabled]="isPendingConfirmation">保存</button>
          <button *ngIf="isPendingConfirmation" class="btn btn-force-complete" (click)="onForceComplete()">強制完了</button>
          <button *ngIf="!isPendingConfirmation" class="btn btn-force-complete" (click)="onCancelRequest()">申請取消</button>
        </div>

        <!-- 処理実行ブロック -->
        <div class="execute-block">
          <h3>処理実行</h3>
          <div class="execute-content">
            <div class="period-line">
              <span class="label">変更前：</span>
              <span class="value">{{ getOldPeriod() }}</span>
            </div>
            <div class="period-line">
              <span class="label">変更後：</span>
              <span class="value">{{ getNewPeriod() }}</span>
            </div>
            <div class="button-line">
              <button class="btn btn-success" (click)="onExecuteChange()" [disabled]="!isExecuteButtonEnabled || isPendingConfirmation">変更実行</button>
              <button class="btn btn-secondary" (click)="onAlternativeProcess()" [disabled]="!isAlternativeButtonEnabled || isPendingConfirmation">別処理</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ブロック3: 変更申請リスト（処理済） -->
  <div class="chgrequest-block completed-block">
    <h2 class="block-title">変更申請リスト（処理済）</h2>
    
    <!-- 期間オプションとCSV出力ボタン -->
    <div class="completed-controls">
      <label class="radio-label">
        <input type="radio" name="period" [value]="1" 
          [(ngModel)]="selectedPeriodDays" (change)="onPeriodChange(1)">
        <span>本日</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="period" [value]="2" 
          [(ngModel)]="selectedPeriodDays" (change)="onPeriodChange(2)">
        <span>1週間</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="period" [value]="3" 
          [(ngModel)]="selectedPeriodDays" (change)="onPeriodChange(3)">
        <span>1か月</span>
      </label>
      <button class="btn btn-success csv-btn" (click)="onExportCSV()">CSV出力</button>
    </div>

    <!-- ローディング表示 -->
    <div *ngIf="isLoadingCompleted" class="loading-message">
      読み込み中...
    </div>

    <!-- 処理済リスト表 -->
    <div *ngIf="!isLoadingCompleted" class="table-container">
      <table class="chgrequest-table">
        <thead>
          <tr>
            <th class="text-right">No</th>
            <th class="text-center">獲注番号</th>
            <th class="text-center">ASC登録番号</th>
            <th class="text-center">部署コード</th>
            <th class="text-center">元開始日</th>
            <th class="text-center">元終了日</th>
            <th class="text-center">削除開始日</th>
            <th class="text-center">確定削除日</th>
            <th class="text-left">削除/変更種類</th>
            <th class="text-center">発生日</th>
            <th class="text-center">前払い</th>
            <th class="text-left">状態</th>
            <th class="text-left">支店担当者</th>
            <th class="text-center">処理内容</th>
            <th class="text-left">処理状況</th>
            <th class="text-left">処理担当者</th>
            <th class="text-center">処理更新日時</th>
            <th class="text-left">処理コメント</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let req of completedRequests">
            <td class="text-right">
              <a *ngIf="req.procCode !== -1" (click)="navigateToTransfer(req.requestID)" 
                 style="color: #007bff; text-decoration: underline; cursor: pointer;">
                {{ req.requestID }}
              </a>
              <span *ngIf="req.procCode === -1">{{ req.requestID }}</span>
            </td>
            <td class="text-center">{{ req.jobOrderID }}</td>
            <td class="text-center">
              <a href="javascript:void(0)" class="link-text" (click)="onShowASCInfo(req.userCode)">{{ req.userCode }}</a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" class="link-text" (click)="onShowCustomerInfo(req.customerOfficeCode)">{{ req.customerOfficeCode }}</a>
            </td>
            <td class="text-center">{{ req.oldStartDate | date:'yyyy/M/d' }}</td>
            <td class="text-center">{{ req.oldEndDate | date:'yyyy/M/d' }}</td>
            <td class="text-center">{{ req.cutDate | date:'yyyy/M/d' }}</td>
            <td class="text-center">{{ req.fixCutDate | date:'yyyy/M/d' }}</td>
            <td class="text-left">{{ req.chgReason }}</td>
            <td class="text-center">{{ req.createDate | date:'yyyy/M/d' }}</td>
            <td class="text-center">{{ req.prePay }}</td>
            <td class="text-left">{{ req.dataStatus ?? req.dataStatusCode }}</td>
            <td class="text-left">{{ req.repName }}</td>
            <td class="text-center">
              <span *ngIf="req.procCode === -1">別処理</span>
              <span *ngIf="req.procCode === 0">全削除</span>
              <span *ngIf="req.procCode !== -1 && req.procCode !== 0">TS削除</span>
            </td>
            <td class="text-left">{{ req.procStatus }}</td>
            <td class="text-left">{{ req.procUserName }}</td>
            <td class="text-center">{{ req.procDate }}</td>
            <td class="text-left">{{ req.procComment }}</td>
          </tr>
        </tbody>
      </table>

      <!-- ページング -->
      <div class="pagination-container" *ngIf="completedTotalPages > 1">
        <button 
          class="page-btn" 
          [disabled]="completedPageNo === 1"
          (click)="onCompletedPageChange(completedPageNo - 1)">
          前へ
        </button>
        
        <button 
          *ngFor="let page of getCompletedPageNumbers()"
          class="page-btn" 
          [class.active]="completedPageNo === page"
          (click)="onCompletedPageChange(page)">
          {{ page }}
        </button>
        
        <button 
          class="page-btn" 
          [disabled]="completedPageNo === completedTotalPages"
          (click)="onCompletedPageChange(completedPageNo + 1)">
          次へ
        </button>
        
        <span class="page-info">
          {{ completedPageNo }} / {{ completedTotalPages }} ページ
        </span>
      </div>
    </div>
  </div>

</div>
